import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const updateUnitTechCompany = async (unitId: string, techCompanyId: string): Promise<boolean> =>
  axios.post(`/unit/updateunittechcompany`, { unitId, techCompanyId }).then((res) => res?.data?.result)

type Props = {
  unitId: string
  techCompanyId: string
}

export const useUpdateUnitTechCompany = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['updateUnitTechCompany'],
    mutationFn: ({ unitId, techCompanyId }: Props) => updateUnitTechCompany(unitId, techCompanyId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Updated technician.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to update technician, please try again.')
      }
    },
    throwOnError: false
  })
